<template>
  <div id="signature-collection">
    <h1 class="heading p-5 text-xl sm:text-lg md:text-2xl lg:text-3xl text-center text-gray-700 border-b border-b-1 border-mlt-grey">Signature Collection</h1>

    <v-container class="p-3">
      <ul id="signature-list">
        <li v-if="loading">
          <Loading />
        </li>

        <li v-else class="grid grid-flow-row grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 transform scale-100 opacity-100">
          <v-card
            flat
            hover
            :href="product.permalink"
            target="_blank"
            outlined
            v-for="(product, index) in products"
            :key="index"
          >
            <v-img :alt="product.name" :src="product.images[0].src"></v-img>
          </v-card>
        </li>
      </ul>
    </v-container>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import { mapGetters, mapState } from 'vuex';

export default {
  name: "SignatureCollection",

  components: {
    Loading,
  },

  created: function () {
  },

  computed: {
    ...mapState({
      axiosWc: "axiosWc",
    }),
    ...mapGetters({
      getUrlApi: "getUrlApi",
    }),
  },

  mounted: function () {
    this.getProducts();
  },

  data: function () {
    return {
      client: null,
      loading: null,
      products: {},
    };
  },

  methods: {
    getProducts: async function() {
      this.loading = true;
      const res = await this.axiosWc.get(this.getUrlApi + '/wc/v3/products/');
      this.products = res.data;
      this.loading = false;
    },
  },
}
</script>

<style>

</style>